// Совместимость со старыми движками Android (System WebView без обновлений, например Huawei без сервисов
// Google: Chrome 92). Без этого замок и карта не рисуются: каждый кадр падал на отсутствующем методе.

type Radii = number | DOMPointInit | (number | DOMPointInit)[] | undefined;

function radius(r: Radii): number {
  const first = Array.isArray(r) ? r[0] : r;
  if (typeof first === 'number') return first;
  return first?.x ?? 0;
}

/** roundRect (Chrome 99+): путь скруглённого прямоугольника через arcTo. */
function roundRect(this: CanvasPath, x: number, y: number, w: number, h: number, radii?: Radii): void {
  const r = Math.max(0, Math.min(radius(radii), Math.abs(w) / 2, Math.abs(h) / 2));
  this.moveTo(x + r, y);
  this.arcTo(x + w, y, x + w, y + h, r);
  this.arcTo(x + w, y + h, x, y + h, r);
  this.arcTo(x, y + h, x, y, r);
  this.arcTo(x, y, x + w, y, r);
  this.closePath();
}

if (typeof window !== 'undefined') {
  for (const proto of [window.CanvasRenderingContext2D?.prototype, window.Path2D?.prototype]) {
    if (proto && !('roundRect' in proto))
      Object.defineProperty(proto, 'roundRect', { value: roundRect, configurable: true, writable: true });
  }
}

export {};
